import React, { useState, useEffect } from "react";

export default function SkeletonWalletLoader() {
  return (
    <div
      className="min-h-auto bg-[#181818] select-none"
      role="status"
      aria-busy="true"
    >
      {/* Header Skeleton */}
      <div className="bg-gradient-to-r h-[58px] px-5 bg-[rgba(47,47,50,0.4)] flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-white/20 animate-pulse" aria-hidden="true" />
          <div className="space-y-2">
            <div className="h-4 w-16 bg-white/30 rounded animate-pulse" aria-hidden="true" />
            <div className="h-3 w-20 bg-white/20 rounded animate-pulse" aria-hidden="true" />
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-white/20 animate-pulse" aria-hidden="true" />
          <div className="h-8 w-20 bg-white/20 rounded-full animate-pulse" aria-hidden="true" />
        </div>
      </div>

      <div className="p-4 space-y-4 max-w-4xl mx-auto">
        <div className="relative bg-slate-700/50 backdrop-blur-sm rounded-3xl p-6 overflow-hidden">
          <div className="absolute inset-0 -translate-x-full shimmer pointer-events-none" aria-hidden="true" />

          <div className="relative z-10 space-y-4">
            <div className="flex items-center justify-between">
              <div className="h-4 w-28 bg-slate-600/50 rounded animate-pulse" aria-hidden="true" />
              <div className="flex gap-2">
                <div className="w-10 h-10 rounded-lg bg-slate-600/50 animate-pulse" aria-hidden="true" />
                <div className="w-10 h-10 rounded-lg bg-slate-600/50 animate-pulse" aria-hidden="true" />
              </div>
            </div>

            <div className="space-y-2">
              <div className="h-12 w-32 bg-slate-600/50 rounded animate-pulse" aria-hidden="true" />
              <div className="h-3 w-24 bg-slate-600/50 rounded animate-pulse" aria-hidden="true" />
            </div>

            <div className="space-y-2 pt-2">
              <div className="h-3 w-24 bg-slate-600/50 rounded animate-pulse" aria-hidden="true" />
              <div className="h-16 bg-slate-600/30 rounded-lg animate-pulse" aria-hidden="true" />
            </div>

            <div className="flex gap-3 pt-2">
              <div className="h-12 flex-1 bg-red-500/30 rounded-lg animate-pulse" aria-hidden="true" />
              <div className="h-12 flex-1 bg-slate-600/50 rounded-lg animate-pulse" aria-hidden="true" />
            </div>
          </div>
        </div>

        {/* Send/Receive Buttons Skeleton */}
        <div className="grid grid-cols-2 gap-4">
          <div className="relative bg-slate-700/50 backdrop-blur-sm rounded-2xl p-6 overflow-hidden">
            <div className="absolute inset-0 -translate-x-full shimmer delay-500 pointer-events-none" aria-hidden="true" />
            <div className="relative z-10 flex flex-col items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-slate-600/50 animate-pulse" aria-hidden="true" />
              <div className="h-4 w-12 bg-slate-600/50 rounded animate-pulse" aria-hidden="true" />
            </div>
          </div>

          <div className="relative bg-slate-700/50 backdrop-blur-sm rounded-2xl p-6 overflow-hidden">
            <div className="absolute inset-0 -translate-x-full shimmer delay-500 pointer-events-none" aria-hidden="true" />
            <div className="relative z-10 flex flex-col items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-slate-600/50 animate-pulse" aria-hidden="true" />
              <div className="h-4 w-16 bg-slate-600/50 rounded animate-pulse" aria-hidden="true" />
            </div>
          </div>
        </div>

        {/* Market Trend Section Skeleton */}
        <div className="space-y-3">
          <div className="h-6 w-32 bg-slate-700/50 rounded animate-pulse" aria-hidden="true" />
          <div className="relative bg-slate-700/50 backdrop-blur-sm rounded-2xl p-4 h-48 overflow-hidden">
            <div className="absolute inset-0 -translate-x-full shimmer delay-1000 pointer-events-none" aria-hidden="true" />
            <div className="relative z-10 space-y-3">
              <div className="h-4 w-full bg-slate-600/50 rounded animate-pulse" aria-hidden="true" />
              <div className="h-4 w-5/6 bg-slate-600/50 rounded animate-pulse" aria-hidden="true" />
              <div className="h-4 w-4/6 bg-slate-600/50 rounded animate-pulse" aria-hidden="true" />
              <div className="h-4 w-full bg-slate-600/50 rounded animate-pulse" aria-hidden="true" />
              <div className="h-4 w-3/6 bg-slate-600/50 rounded animate-pulse" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
